import type { Practitioner, Reference } from '@medplum/fhirtypes'
import { codeableConcept } from '#src/codeableConcept.ts'
import {
  BASIC_CODE_SYSTEM,
  ORDER_VIEW_FILTERS_SYSTEM,
  VIEW_ACCESS_TAG_SYSTEM,
} from '#src/codeSystems.ts'
import { Extension } from '#src/decorators.ts'
import { View, type ViewAccess } from '#src/models/view.ts'
import type { QueryTypes } from '#src/search.ts'

export class OrderView extends View {
  constructor({
    name,
    filters,
    owner,
    access,
  }: {
    name: string
    filters: string
    owner: Reference<Practitioner>
    access?: ViewAccess
  }) {
    super({
      code: codeableConcept(OrderView.code),
      name,
      owner,
      access,
    })
    this.filters = filters
  }

  @Extension({
    url: ORDER_VIEW_FILTERS_SYSTEM,
    kind: 'valueString',
  })
  filters: string

  static queryForPractitioner(
    practitioner: Reference<Practitioner>
  ): QueryTypes {
    return {
      code: OrderView.code,
      _tag: View.status.active,
      _filter: `(_tag eq ${VIEW_ACCESS_TAG_SYSTEM}|${practitioner.reference} or _tag eq ${VIEW_ACCESS_TAG_SYSTEM}|shared)`,
      _sort: 'identifier',
      _count: '1000',
    }
  }

  static code = {
    system: BASIC_CODE_SYSTEM,
    code: 'order-view',
    display: 'Order View',
  }
}
